export default __webpack_public_path__ + "static/30-1a034b50201e5cb4218b2e4ab783f0cc.gif";